import { useEffect, useRef, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  Navigate,
} from "react-router-dom";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Journey from "@/components/Journey";
import Challenges from "@/components/Challenges";
import MethodsBento from "@/components/MethodsBento";
import ResultsMarquee from "@/components/ResultsMarquee";
import CTA from "@/components/CTA";
import Footer from "@/components/Footer";
import JoinModal from "@/components/JoinModal";
import { AuthProvider, useAuth } from "@/auth/AuthContext";
import AuthCallback from "@/auth/AuthCallback";
import Dashboard from "@/pages/Dashboard";

const Landing = () => {
  const [joinOpen, setJoinOpen] = useState(false);
  const { user, login } = useAuth();
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      smoothTouch: false,
    });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);

    const handleAnchor = (e) => {
      const a = e.target.closest("a");
      if (!a) return;
      const href = a.getAttribute("href");
      if (href && href.startsWith("#") && href.length > 1) {
        const el = document.querySelector(href);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -80, duration: 1.4 });
        }
      }
    };
    document.addEventListener("click", handleAnchor);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      document.removeEventListener("click", handleAnchor);
    };
  }, []);

  const triggerJoin = () => {
    if (!user) {
      login();
      return;
    }
    setJoinOpen(true);
  };

  return (
    <div className="App grain relative" data-testid="app-root">
      <Navbar onJoin={triggerJoin} />
      <main>
        <Hero />
        <Journey />
        <Challenges />
        <MethodsBento />
        <ResultsMarquee />
        <CTA onJoin={triggerJoin} />
      </main>
      <Footer />
      <JoinModal open={joinOpen} onClose={() => setJoinOpen(false)} />
    </div>
  );
};

const Shell = () => {
  const location = useLocation();
  // Detect emergent OAuth callback synchronously during render
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Shell />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
